import { render, staticRenderFns } from "./latests.vue?vue&type=template&id=fc95ea42&"
import script from "./latests.vue?vue&type=script&lang=js&"
export * from "./latests.vue?vue&type=script&lang=js&"
import style0 from "./latests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc95ea42')) {
      api.createRecord('fc95ea42', component.options)
    } else {
      api.reload('fc95ea42', component.options)
    }
    module.hot.accept("./latests.vue?vue&type=template&id=fc95ea42&", function () {
      api.rerender('fc95ea42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/componetsPage/latests.vue"
export default component.exports